import React, { useMemo, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useIntl } from 'react-intl';
import { useFilterObjectsUIContext } from "../FilterObjectsUIContext";
import { isEqual } from "lodash";
import { shallowEqual, useSelector } from "react-redux";
// import moment from "moment-jalaali";


export const ObjectEditForm = ({
  formFields,
  otherFields,
  ObjectEditSchema,
  object,
  btnRef,
  saveObject,
  isFullAccess,
  prepareFilter,
}) => {

  const filterUIContext = useFilterObjectsUIContext();
  const objectsUIProps = useMemo(() => {
    return {
      queryParams: filterUIContext.queryParams,
      setQueryParams: filterUIContext.setQueryParams,
    };
  }, [filterUIContext]);

  const { user } = useSelector(
    (state) => ({ user: state.auth.user }),
    shallowEqual
  );

  const createFields = (field, index, setFieldValue, values, handleSubmit, onChange) => {

    if (field.disabled === undefined) field.disabled = false;

    if (field.type === "select") {
      return (
        <div key={field.rowIdx} className={field.class}>
          <Field
            name={field.name}
            component={field.component}
            placeholder={intl.formatMessage({ id: field.placeholder })}
            label={intl.formatMessage({ id: field.label })}
            type={field.type}
            as={field.as}
            disabled={!isFullAccess || field.disabled}
            // onChange={(e) => {
            //   field.handleChange({
            //     val:e.currentTarget.value,
            //     object,
            //     values,
            //     setFieldValue,
            //     applyFilter
            //   });
            // }}
            onChange={(e) => {
              handleChangeLocal({
                val: e.currentTarget.value,
                field,
                setFieldValue,
                values
              });
            }}
          // value={values[field.name]}
          />
        </div>
      );
    }
    else if (field.type === "search") {
      return (
        <div key={field.rowIdx} className={field.class}>
          <Field
            name={field.name}
            component={field.component}
            placeholders={field.placeholder}
            baseplaceholder={field.baseplaceholder}
            // placeholder={intl.formatMessage({ id: field.placeholder })}
            label={intl.formatMessage({ id: field.label })}
            type={field.type}
            as={field.as}
            disabled={!isFullAccess || field.disabled}
            value={values[field.name]}
            onChange={(e) => {
              if (e)
                setFieldValue(field.name, e.target.value);
              // handleSubmit();
            }}
          />
        </div>
      );
    }
    // else if (field.type === "date") {
    //   return (
    //     <div key={field.rowIdx} className={field.class}>
    //       <Field
    //         name={field.name}
    //         component={field.component}
    //         placeholder={intl.formatMessage({ id: field.placeholder })}
    //         label={intl.formatMessage({ id: field.label })}
    //         type={field.type}
    //         as={field.as}
    //         disabled={!isFullAccess || !field.disabled}
    //         onChange={(e) => {
    //           handleChangeDate({
    //             val: e,
    //             field,
    //             setFieldValue,
    //             values
    //           });
    //         }}
    //         //onBlur={onChange} // only change on blur
    //         value={moment(values[field.name])}
    //       />
    //     </div>
    //   );
    // }
    else {
      return (
        <div key={field.rowIdx} className={field.class}>
          <Field
            name={field.name}
            component={field.component}
            placeholder={intl.formatMessage({ id: field.placeholder })}
            label={intl.formatMessage({ id: field.label })}
            type={field.type}
            as={field.as}
            disabled={!isFullAccess || field.disabled}
          // value={values[field.name]}
          />
        </div>
      );
    }

  };

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(objectsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, objectsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      objectsUIProps.setQueryParams(newQueryParams);
    }

  };

  const handleChangeLocal = ({ val, field, setFieldValue, values }) => {
    const temp = { ...object };
    temp[field.name] = val;
    setFieldValue(field.name, +val);
    field.relField.forEach(element => {
      setFieldValue(element, 0);
      temp[element] = 0
    });

    values = {
      ...values,
      ...field.relValues
    }

    values[field.name] = +val

    applyFilter(temp);
    console.log("values")
    console.log(values)
  };

  // const handleChangeDate = ({ val, field, setFieldValue, values }) => {
  //   console.log("handleChangeDate values")

  //   // if ((new Date(val) > new Date(field.value)) || (new Date(val) < new Date(field.value)))
  //   setFieldValue(field.name, createDateAsUTC(new Date(val)));

  //   console.log(values)

  // };

  const intl = useIntl();

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={object}
        validationSchema={ObjectEditSchema}
        onSubmit={(values) => {

          if (values.creatorUserId !== undefined) {
            values["creatorUserId"] = user.id
          }

          saveObject(values);
          console.log("Save values")
          console.log(values)
        }}

      >
        {({ handleSubmit, setFieldValue, values, onChange }) => (
          <>
            <Form className="form form-label-right">
              {formFields.map(formRow =>
                <div key={formRow.row} className="form-group row">
                  {formRow.list.map((field, index) =>
                    createFields(field, index, setFieldValue, values, handleSubmit, onChange)
                    // <div key={index} className={field.class}>
                    //   <Field
                    //     name={field.name}
                    //     component={field.component}
                    //     placeholder={intl.formatMessage({ id: field.placeholder })}
                    //     label={intl.formatMessage({ id: field.label })}
                    //     type={field.type}
                    //     as={field.as}
                    //     disabled={!isFullAccess}
                    //   // onChange={handleChange}
                    //   />
                    // </div>
                  )}
                </div>
              )}


              {otherFields.map((ofield, index) =>
                <div key={index} className="form-group">
                  <label>{intl.formatMessage({ id: ofield.lable })}</label>
                  <Field
                    name={ofield.name}
                    as={ofield.as}
                    className={ofield.class}
                    disabled={!isFullAccess}
                  />
                </div>
              )}

              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}




